// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconArrowDownCopper: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="7" viewBox="0 0 11 7" fill="currentColor">
            <polygon
                fill="currentColor"
                points="300.4 727 299 728.375 303.2 732.5 299 736.625 300.4 738 306 732.5"
                transform="rotate(90 518.5 219.5)"
            />
        </svg>
    );
};

export default React.memo(IconArrowDownCopper);
